import api from "./api";

const McpKeyService = {
  list: async () => {
    const { data } = await api.get("/api/mcp-keys/");
    return data;
  },

  create: async (args) => {
    const body = { name: args.name };
    const { data } = await api.post("/api/mcp-keys/", body);
    return data;
  },

  revoke: async (args) => {
    await api.delete(`/api/mcp-keys/${args.id}/`);
    return args.id;
  },
};

export default McpKeyService;
